import { nChoses } from './accords';
import { IMPOSE, PLANIFIER_CE_JOUR, QUEL_PROJET } from './journee';
import { TOUS_LES_PROJETS } from './maintenant';

/** Les mots de l'Agenda, sur l'ordinateur et au téléphone. */

/*
 * L'Agenda de l'ordinateur d'après sa maquette (chantier `revue-design`, ticket 06) : Calendrier
 * à l'ouverture, l'export en haut, la journée préparée d'un mot dans sa case.
 */
export const CHRONOLOGIE = 'Chronologie';
export const CALENDRIER = 'Calendrier';
export const ENVOYER_DANS_MON_AGENDA = 'Envoyer dans mon agenda';
export const ENVOYER_DANS_MON_AGENDA_TITRE = 'Un fichier .ics avec ce qui est daté, pour ton agenda habituel';
export const AUJOURDHUI_DANS_SA_CASE = 'aujourd’hui';
/** « Journée : 4 choses, dès 9 h 30 », dans la case du jour. */
export function journeeEnBref(combien: number, heure: string): string {
  return `Journée : ${nChoses(combien)}, dès ${heure}`;
}
/**
 * L'angle Agenda d'une feuille sans rien de daté (chantier angles-du-projet, ticket 03) : un mot à
 * la place de la page de présentation, qui parle de tous les projets.
 */
export const RIEN_DE_DATE_ICI = 'Rien de daté ici : ni rendez-vous, ni échéance, ni réponse attendue.';
/** « 2 dates choisies » pour l'export, dans la Chronologie. */
export function datesChoisies(combien: number): string {
  return `${combien} ${combien > 1 ? 'dates choisies' : 'date choisie'}`;
}
/** « 5 possibles », « 2 choisies · 5 possibles » : comme la maquette, rien choisi se tait. */
export function choisiesEtPossibles(choisies: number, possibles: number): string {
  const p = `${possibles} ${possibles > 1 ? 'possibles' : 'possible'}`;
  return choisies > 0 ? `${choisies} ${choisies > 1 ? 'choisies' : 'choisie'} · ${p}` : p;
}

/** L'Agenda au téléphone (ticket 10 de telephone, `design/telephone.html`, « Agenda »). */
export const MOTS_AGENDA_AU_POUCE = {
  titre: 'Agenda',
  bascule: 'Comment regarder l’Agenda',
  semaine: 'Semaine',
  mois: 'Mois',
  semaineAvant: 'La semaine d’avant',
  semaineApres: 'La semaine d’après',
  moisAvant: 'Le mois d’avant',
  moisApres: 'Le mois d’après',
  aujourdhui: 'Aujourd’hui',
  rienDePose: 'Rien de posé',
  exporter: 'Exporter vers mon agenda',
  exporterRien: 'Rien à exporter cette semaine : ni rendez-vous ni échéance.',
  toucherUnJour: 'Touche un jour pour tout voir.',
  // La semaine en cartes (chantier `telephone-journee-agenda`, ticket 05, décision 17 de la revue).
  tousLesProjets: TOUS_LES_PROJETS,
  quelProjet: QUEL_PROJET,
  revoirTousLesProjets: 'Revoir tous les projets',
  echeance: 'Échéance',
  reponseAttendue: 'Réponse attendue',
  reponsePasVenue: 'Réponse attendue, pas venue',
  chevauche: 'Chevauche',
  chevaucheExplique: 'Chevauche un autre rendez-vous',
  tachesDeLaJournee: (n: number, heure: string) => `${n} ${n > 1 ? 'tâches' : 'tâche'} · dès ${heure}`,
  relancer: 'Relancer',
  arrive: 'C’est arrivé',
  ouvrirLaFiche: 'Ouvrir la fiche ›',
  relancee: (titre: string) => `Relancée : ${titre}`,
  arrivee: (titre: string) => `Arrivée : ${titre}`,
  retourSemaine: '‹ La semaine',
  retourMois: '‹ Le mois',
  aVenir: 'À venir',
  passe: 'Passé',
  rendezVous: 'Rendez-vous',
  taJournee: 'Ta journée',
  rienCeJourLa: 'Rien de posé ce jour-là.',
  // Un jour sans journée, aujourd'hui compris : « Planifier ce jour » pose la question
  // (chantier `telephone-journee-agenda`, ticket 01, décision d'Igor du 2026-10-05, 20).
  preparer: PLANIFIER_CE_JOUR,
  changer: 'Changer ce jour',
  planifier: PLANIFIER_CE_JOUR,
  changerAujourdhui: 'Changer ma journée',
  ouvrir: (jour: string) => `Ouvrir ${jour}`,
  faite: 'Faite',
  // Le mois et le jour ouvert (chantier `telephone-journee-agenda`, ticket 06, décisions 18 et 19
  // de la revue) : des barres dans le mois, le jour touché dessous, puis en entier.
  voir: (jour: string) => `Voir ${jour}`,
  deplus: (n: number) => `+${n}`,
  ouvrirLeJour: 'Ouvrir',
  pasDeJourneePrevue: 'Pas de journée prévue',
  impose: IMPOSE,
  ceQuiDoitArriver: 'Ce qui doit arriver',
  relancerPour: (titre: string) => `Relancer « ${titre} »`,
} as const;
